import React from "react";

function PersonIcon({ stroke }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 21.5C4 18.5179 6.388 16.1 9.33333 16.1H14.6667C17.612 16.1 20 18.5179 20 21.5"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8284 3.67157C16.3905 5.23367 16.3905 7.76633 14.8284 9.32843C13.2663 10.8905 10.7337 10.8905 9.17157 9.32843C7.60948 7.76633 7.60948 5.23367 9.17157 3.67157C10.7337 2.10948 13.2663 2.10948 14.8284 3.67157"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default PersonIcon;
